import { accommodationsCurrencySymbolByCountry, currencySymbolByPointOfSale, flyAnywhereCurrencySymbolByPointOfSale } from "./pointOfSaleToCurrency.js";
export const getCurrencySymbolByPointOfSale = (pointOfSale) => {
    return currencySymbolByPointOfSale[pointOfSale];
};
export const getFlyAnywhereCurrencySymbolByPointOfSale = (pointOfSale) => {
    return flyAnywhereCurrencySymbolByPointOfSale[pointOfSale];
};
export const getAccommodationsCurrencySymbolByCountry = (countryCode) => {
    return accommodationsCurrencySymbolByCountry[countryCode];
};
export const SUPPORTED_CURRENCIES = [
    "EUR",
    "USD",
    "SEK",
    "NOK",
    "DKK",
    "GBP",
    "AUD",
    "UAH",
    "PLN",
    "CHF",
    "QAR",
    "PHP",
    "THB",
    "AED",
    "CLP",
    "CZK",
    "HUF",
    "ISK",
    "INR",
    "IDR",
    "BHD",
    "KWD",
    "RSD",
    "OMR",
    "HKD",
    "CAD",
    "JPY",
    "BGN",
    "MXN",
    "COP",
    "NZD",
    "KZT",
    "PEN",
    "BRL",
    "MYR",
    "SAR",
    "KRW",
    "SGD"
];
export const isValidCurrency = (currency) => {
    const currencyUpper = currency.toUpperCase();
    return SUPPORTED_CURRENCIES.includes(currencyUpper);
};
